import { AccessRole } from 'lib/const';
import { CUSTOM_REPORT_STEPS, IRecipient, STEPS } from './types';
import { TFunction } from 'i18next';

export const getSteps = ({
  isCompanyAdmin,
  isResellerAdmin,
  t,
}: {
  isCompanyAdmin: boolean;
  isResellerAdmin: boolean;
  t: TFunction;
}): STEPS => {
  const steps = [
    ...(isCompanyAdmin || isResellerAdmin
      ? [
          {
            value: CUSTOM_REPORT_STEPS.USERS,
            label: t('Users'),
            errorName: 'users',
          },
        ]
      : []),
    { value: CUSTOM_REPORT_STEPS.DATA, label: t('Data'), errorName: 'reports' },
    {
      value: CUSTOM_REPORT_STEPS.TIMEFRAME,
      label: t('Timeframe'),
      errorName: 'isTimeFrameStep',
    },
    {
      value: CUSTOM_REPORT_STEPS.BASICS,
      label: t('Finalize'),
      errorName: 'title',
    },
  ];

  return steps;
};

export const timeRangeConstants = {
  TODAY: 'today',
  YESTERDAY: 'yesterday',
  LAST_WEEK: 'last_7_days',
  LAST_MONTH: 'last_month',
  MONTH_TO_DATE: 'month_to_date',
  LAST_7_DAYS: 'previous_7_days',
  LAST_30_DAYS: 'last_30_days',
  YEAR_TO_DATE: 'year_to_date',
  CUSTOM: 'custom',
};

export const getDailyTimeRangeOptions = (t: TFunction) => [
  {
    value: timeRangeConstants.TODAY,
    label: t('Today'),
  },
  {
    value: timeRangeConstants.YESTERDAY,
    label: t('Yesterday'),
  },
];

export const getMonthlyTimeRangeOptions = (t: TFunction) => [
  {
    value: timeRangeConstants.LAST_MONTH,
    label: t('Last Month'),
  },
  {
    value: timeRangeConstants.MONTH_TO_DATE,
    label: t('Month to Date'),
  },
  {
    value: timeRangeConstants.LAST_30_DAYS,
    label: t('Last 30 days'),
  },
];

export const getWeeklyTimeRangeOptions = (t: TFunction) => [
  {
    value: timeRangeConstants.LAST_WEEK,
    label: t('Last Week'),
  },

  {
    value: timeRangeConstants.LAST_7_DAYS,
    label: t('Last 7 days'),
  },
];

export const getYearlyTimeRangeOptions = (t: TFunction) => [
  {
    value: timeRangeConstants.YEAR_TO_DATE,
    label: t('Year to Date'),
  },
];

export const getCustomTimeRangeOptions = (t: TFunction) => [
  {
    value: timeRangeConstants.CUSTOM,
    label: t('Custom...'),
  },
];

export const RecipientTypeALL = '0';
export const getRecipientTypeOptions = (t: TFunction) => [
  {
    value: RecipientTypeALL,
    label: t('All Users'),
  },
  {
    value: AccessRole.ADMIN,
    label: t('All Managers'),
  },
  {
    value: AccessRole.SUPERVISOR,
    label: t('All Supervisors'),
  },
  {
    value: AccessRole.USER,
    label: t('All Standard Users'),
  },
];

export const getTheAccessRole = (access?: String) => {
  if (!access) {
    return '';
  }

  switch (access) {
    case AccessRole.ADMIN:
      return 'Manager';
    case AccessRole.SUPERVISOR:
      return 'Supervisor';
    case AccessRole.USER:
    default:
      return 'Standard';
  }
};

export const getAdditionalRecipients = (receivers: IRecipient[]) =>
  receivers.filter(receiver => !receiver.id);

export const getAdditionalRecipientEmails = (receivers: IRecipient[]) =>
  getAdditionalRecipients(receivers).map(receiver => receiver.email);

export const getUserRecipients = (receivers: IRecipient[]) =>
  receivers.filter(receiver => !!receiver.id);

export const checkDuplicatesIn = (
  userRecipients: IRecipient[],
  additionalRecipients: string[]
) => {
  const userRecipientsSet = new Set(userRecipients.map(obj => obj.email));
  return !!additionalRecipients.find(email => userRecipientsSet.has(email));
};
